import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { ContentEventListAllPageQuery } from '@custom/schema';

export const useContentEventListAllPageQuery = () =>
  useStaticQuery<ContentEventListAllPageQuery>(graphql(ContentEventListAllPageQuery));
